export enum IssueParty {
    None = "None",
    Office = "Office",
    Customer = "Customer",
    Both = "Both"
}
